module.exports = __webpack_public_path__ + "static/media/ic-edit.05406609.svg";